import { Box, Stack } from '@mui/material';

import { NewConvergeNotes } from '../newNotes';
import { NoteTargetAreaType } from '@converge/graphql';

interface IBrokerNoteContainerProps {
  brokerageUuid: string | undefined;
}

export const BrokerageNoteContainer = ({
  brokerageUuid,
}: IBrokerNoteContainerProps) => {
  return (
    //Todo targetname targetuuid and targetType needs to be update
    <>
      <Stack>
        <Stack>
          <Box>
            <NewConvergeNotes
              title="Brokerage Notes"
              targetUuid={brokerageUuid}
              targetArea={NoteTargetAreaType.Entity}
              hideHeader={false}
              containerWidth={12}
              testId="broker-notes"
              inputTestId="note-input"
              buttonTestId="save-note-button"
            />
          </Box>
        </Stack>
      </Stack>
    </>
  );
};
